module.exports = __webpack_public_path__ + "media/purple-finch-2.07f2e7da.mp3";